/* eslint-disable */
import { GetterTree } from "vuex";
import { Proceed } from "@/models/proceed";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { ProceedState } from "@/types/proceed";

const getters: GetterTree<ProceedState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  partnerProceeds: (state) => {
    return state.pagination
      ? state.pagination.data.filter(
          (item) => !item.is_member_target && !item.per_offer
        )
      : [];
  },
  memberProceeds: (state) => {
    return state.pagination
      ? state.pagination.data.filter(
          (item) => item.is_member_target && !item.per_offer
        )
      : [];
  },
  offerProceeds: (state) => {
    return state.pagination
      ? state.pagination.data.filter((item) => !!item.per_offer)
      : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Proceed();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((proceed) => Proceed.toSelectItem(proceed))
      : [];
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((proceed) => {
          return proceed.id == id;
        })
      : new Proceed();
  },
};

export default getters;
